import React from "react";
import { CheckCircle, Shield, Zap, Users } from "lucide-react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";

const features = [
  {
    icon: CheckCircle,
    title: "Reliable Solutions",
    desc: "We deliver high-quality and dependable IT solutions tailored to your business needs.",
  },
  {
    icon: Zap,
    title: "Fast Performance",
    desc: "Optimized systems and infrastructure for speed, efficiency, and scalability.",
  },
  {
    icon: Shield,
    title: "Strong Security",
    desc: "Advanced security solutions to protect your data and systems from threats.",
  },
  {
    icon: Users,
    title: "Expert Team",
    desc: "Experienced professionals dedicated to delivering the best results.",
  },
];

function WhyChooseUs() {
  return (
    <div className="bg-[#050518] py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
        <SectionHeading
          theme="dark"
          badge="WHY CHOOSE US"
          title="Why"
          highlight="Choose Us"
          description="Modern IT solutions backed by experienced professionals and enterprise-grade support."
        />
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, i) => {
            const Icon = item.icon;
            return (
                <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              
                animate={{ y: [0, -8, 0] }}
              
                transition={{
                  opacity: { duration: 0.6, delay: i * 0.2 },
                  y: {
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: i * 0.3,
                  },
                }}
              
                className="group p-6 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-lg
                shadow-[0_10px_30px_rgba(0,0,0,0.4)]
                hover:shadow-[0_20px_60px_rgba(124,92,250,0.5)]
                hover:-translate-y-2 transition duration-500"
              >
              
                {/* Icon */}
                <motion.div
                  animate={{ rotate: [0, 5, -5, 0] }}
                  className="mb-4 inline-flex p-3 rounded-xl bg-gradient-to-r from-pink-500 to-purple-500 shadow-lg"
                >
                  <Icon className="text-white" size={20} />
                </motion.div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-400">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default  WhyChooseUs;